import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts';

export function StockChart({ pieData }) {
  return (
    <Card>
      <CardHeader><CardTitle>Stock Distribution</CardTitle></CardHeader>
      <CardContent>
        {pieData.length > 0 ? (
          <ResponsiveContainer width="100%" height={200}>
            <PieChart>
              <Pie data={pieData} cx="50%" cy="50%" outerRadius={70} dataKey="value" label>
                {pieData.map(function(entry, index) {
                  return <Cell key={'cell-' + index} fill={entry.color} />;
                })}
              </Pie>
              <Tooltip />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-[200px] flex items-center justify-center text-muted-foreground">No inventory data</div>
        )}
      </CardContent>
    </Card>
  );
}
